module.exports = __webpack_public_path__ + "static/media/82.bf17a663.jpg";